const form = {
  formId: "new-user-form",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label: "HKD, CNKD nộp thuế theo phương pháp khoán",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "CNKD nộp thuế theo từng lần phát sinh",
      type: "text",
    },
    checkbox3: {
      name: "checkbox3",
      label: "Tổ chức, cá nhân khai thuế thay, nộp thuế thay",
      type: "text",
    },
    checkbox4: {
      name: "checkbox4",
      label: "HKD, CNKD nộp thuế theo phương pháp kê khai",
      type: "text",
    },
    checkbox5: {
      name: "checkbox5",
      label:
        "HKD, CNKD trong lĩnh vực ngành nghề có căn cứ xác định được doanh thu theo xác nhận của cơ quan chức năng",
      type: "text",
    },
    checkbox6: {
      name: "checkbox6",
      label: "Hộ khoán chuyển đổi phương pháp tính thuế",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    field01a: {
      name: "field01a",
      label: "[01a] Năm",
      type: "number",
      placeholder: "2023",
      errorMsg: "Vui lòng nhập năm",
    },
    field01b: {
      name: "field01b",
      label: "[01b] Kỳ thanh toán",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    field01c: {
      name: "field01c",
      label: "[01c] Tháng / năm",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    field01d: {
      name: "field01d",
      label: "[01d] Từ tháng / Đến tháng",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    shopName: {
      name: "shopName",
      label: "[05] Tên cửa hàng/thương hiệu",
      type: "text",
      errorMsg: "Vui lòng nhập tên cửa hàng/thương hiệu",
    },
    bankNumber: {
      name: "bankNumber",
      label: "[06] Tên cửa hàng/thương hiệu",
      type: "text",
      errorMsg: "Vui lòng nhập tên cửa hàng/thương hiệu",
    },
    taxId: {
      name: "taxId",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    career: {
      name: "career",
      label: "[08] Ngành nghề kinh doanh",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngành nghề kinh doanh",
    },
    checkbox7: {
      name: "checkbox7",
      label: "Thay đổi thông tin",
      type: "text",
    },
    acreage: {
      name: "acreage",
      label: "[09] Diện tích kinh doanh",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích kinh doanh",
    },
    checkbox8: {
      name: "checkbox8",
      label: "[09a] Đi thuê",
      type: "text",
    },
    quantityUse: {
      name: "quantityUse",
      label: "[10] Số lượng lao động sử dụng thường xuyên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    timeActivityFrom: {
      name: "timeActivityFrom",
      label: "[11] Thời gian hoạt động trong ngày (Từ)",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    timeActivityTo: {
      name: "timeActivityTo",
      label: "[11] Thời gian hoạt động trong ngày (Đến)",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    businessAddress: {
      name: "businessAddress",
      label: "[12] Địa chỉ kinh doanh",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    checkbox9: {
      name: "checkbox9",
      label: "[12a] Thay đổi thông tin",
      type: "text",
    },
    province: {
      name: "province",
      label: "[12.đ] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh / thành phố",
    },
    district: {
      name: "district",
      label: "[12.d] Quận/Huyện/Thị xã/Tp thuộc tỉnh ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Quận/Huyện/Thị xã/Tp thuộc tỉnh",
    },
    ward: {
      name: "ward",
      label: "[12.c] Phường/Xã/Thị trấn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Phường/Xã/Thị trấn",
    },
    address: {
      name: "address",
      label: "[12.b] Số nhà, đường phố/xóm/ấp/thôn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Số nhà, đường phố/xóm/ấp/thôn",
    },
    checkbox10: {
      name: "checkbox10",
      label: "[12.e] Kinh doanh tại chợ biên giới",
      type: "text",
    },
    address2: {
      name: "address2",
      label: "[13] Địa chỉ cư trú",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Địa chỉ cư trú",
    },
    province2: {
      name: "province2",
      label: "[13.d] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh / thành phố",
    },
    district2: {
      name: "district2",
      label: "[13.c] Quận/Huyện/Thị xã/Tp thuộc tỉnh ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Quận/Huyện/Thị xã/Tp thuộc tỉnh",
    },
    ward2: {
      name: "ward2",
      label: "[13.b] Phường/Xã/Thị trấn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Phường/Xã/Thị trấn",
    },
    address3: {
      name: "address3",
      label: "[13.a] Số nhà, đường phố/xóm/ấp/thôn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Số nhà, đường phố/xóm/ấp/thôn",
    },

    phone: {
      name: "phone",
      label: "[14] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[15] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[16] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    authDocument: {
      name: "authDocument",
      label: "[17] Văn bản ủy quyền (nếu có):",
      type: "text",
      placeholder: "",
    },
    authDocumentDate: {
      name: "authDocumentDate",
      label: "Ngày",
      type: "number",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[19] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[20] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contract: {
      name: "contract",
      label: "[21] Hợp đồng đại lý thuế:Số:",
      type: "text",
      placeholder: "",
    },
    contractDate: {
      name: "contractDate",
      label: "Ngày",
      type: "number",
    },
    organizationName: {
      name: "organizationName",
      label: "[22] Tên tổ chức khai thay (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxId2: {
      name: "taxId2",
      label: "[23] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address4: {
      name: "address4",
      label: "[24] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    phone2: {
      name: "phone2",
      label: "[25] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax2: {
      name: "fax2",
      label: "[26] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email2: {
      name: "email2",
      label: "[27] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
